import { Box, Button } from '@material-ui/core';
import React from 'react';

export interface Props {
  reset?: () => void;
  save?: () => void;
  applyMyFilters?: () => void;
  disableMyFilters?: boolean;
  disableSaveButton?: boolean;
}

const FilterHeader: React.FC<Props> = ({
  reset,
  save,
  applyMyFilters,
  disableMyFilters,
  disableSaveButton,
}) => (
  <Box display="flex" justifyContent="flex-end">
    {!!reset && (
      <Button variant="text" color="primary" onClick={reset}>
        Reset to Default
      </Button>
    )}
    {!!save && (
      <Button
        variant="text"
        color="primary"
        onClick={save}
        disabled={disableSaveButton}
      >
        Save
      </Button>
    )}
    {!!applyMyFilters && (
      <Button
        variant="text"
        color="primary"
        onClick={applyMyFilters}
        disabled={disableMyFilters}
      >
        My filters
      </Button>
    )}
  </Box>
);

export default FilterHeader;
